// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  hmr: false,
  development: true,
  categoriesModel: [
    {
      "name": "Anne, Bebek & Oyuncak",
      "uniqueName": "anne_bebek_ve_oyuncak",
      "image": "anne_bebek_ve_oyuncak.png"
    },
    {
      "name": "Banka & Sigortacılık Hizmetleri",
      "uniqueName": "banka_ve_sigortacilik_hizmetleri",
      "image": "banka_ve_sigortacilik_hizmetleri.png"
    },
    {
      "name": "Beyaz Eşya & Elektrikli Ev Aletleri",
      "uniqueName": "beyaz_esya_ve_elektrikli_ev_aletleri",
      "image": "beyaz_esya_ve_elektrikli_ev_aletleri.png"
    },
    {
      "name": "E-Ticaret Siteleri",
      "uniqueName": "eticaret_siteleri",
      "image": "eticaret_siteleri.png"
    },
    {
      "name": "Ev, Yaşam & Ofis",
      "uniqueName": "ev_yasam_ve_ofis",
      "image": "ev_yasam_ve_ofis.png"
    },
    {
      "name": "Moda, Giyim & Aksesuar",
      "uniqueName": "moda_giyim_ve_aksesuar",
      "image": "moda_giyim_ve_aksesuar.png"
    },
    {
      "name": "Gıda & Hızlı Tüketim",
      "uniqueName": "gida_ve_hizli_tuketim",
      "image": "gida_ve_hizli_tuketim.png"
    },
    {
      "name": "İnternet & Telekomünikasyon",
      "uniqueName": "internet_ve_telekomunikasyon",
      "image": "internet_ve_telekomunikasyon.png"
    },
    {
      "name": "Kültür, Sanat, Müzik & Medya",
      "uniqueName": "kultur_sanat_muzik_ve_medya",
      "image": "kultur_sanat_muzik_ve_medya.png"
    },
    {
      "name": "Turizm",
      "uniqueName": "turizm",
      "image": "turizm.png"
    },
    {
      "name": "Otomotiv & Motosiklet",
      "uniqueName": "otomotiv_ve_motosiklet",
      "image": "otomotiv_ve_motosiklet.png"
    },
    {
      "name": "Sağlık, Güzellik & Kozmetik",
      "uniqueName": "saglik_guzellik_ve_kozmetik",
      "image": "saglik_guzellik_ve_kozmetik.png"
    },
    {
      "name": "Spor & Aktif Yaşam",
      "uniqueName": "spor_ve_aktif_yasam",
      "image": "spor_ve_aktif_yasam.png"
    },
    {
      "name": "Teknoloji & Elektronik",
      "uniqueName": "teknoloji_ve_elektronik",
      "image": "teknoloji_ve_elektronik.png"
    },
    {
      "name": "Ulaştırma & Lojistik",
      "uniqueName": "ulastirma_ve_lojistik",
      "image": "ulastirma_ve_lojistik.png"
    },
    {
      "name": "Diğer",
      "uniqueName": "diger",
      "image": "diger.png"
    }]
};



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/environments/environment.ts